import { observer } from 'mobx-react-lite'
import React, { useEffect, useState } from 'react'
import { storeElement } from 'GlobalStores/Cores/Elements/StoreElement'
import { Stack, Typography, styled, Box, Dialog, DialogContent } from '@mui/material'
import { runInAction } from 'mobx'
import StoreAuth from 'GlobalStores/User/StoreAuth'
import { FeelGreatAPI } from 'Services/FeelGreat/APIs'
import StoreProducts from 'GlobalStores/StoreProducts'
import StoreUser from 'GlobalStores/User/StoreUser'
import { ReactComponent as RefreshIcon } from './Assets/RefreshIcon.svg'
import { T, useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import ItemSubscriptionsMobile from './ItemSubscriptionsMobile'
import { useNavigate } from 'react-router-dom'
import { DefaultButton } from '../../Forms'
import { ReactComponent as RefreshSVG } from './Assets/iconRefreshDesktop.svg'
import StoreCountry from 'GlobalStores/Cores/County/StoreCountry'
import { useSizeWindow } from 'Helpers/GlobalHelpers'
import BlockingModal from 'Components/Elements/BlockingModal'
import storeFeelGreat from 'GlobalStores/FeelGreat/StoreFeelGreat'

const SubscriptionsMobile = observer(props => {
    const [paymentData, setPaymentData] = useState([])
    const [loading, setLoading] = useState(false)
    const [orderData, setOrderData] = useState([])

    useEffect(() => {
        runInAction(() => {
            storeElement.cardTitle.titleStep1 = <T>subscriptions</T>
            storeElement.settingCard.padding = '0'
        })

        // App bootstrap only fetches this for the anonymous/referral entry flow, never on
        // an already-authenticated reload - fetch it here so Edit/Send Now eligibility is
        // never stuck reading a null config (see isShowEditSubscription in ItemSubscriptionsMobile.js).
        if (!storeFeelGreat.GetSubscriptionConfigData()) {
            FeelGreatAPI.GetSubscriptionConfig().then(res => storeFeelGreat.SetSubscriptionConfigData(res.data))
        }

        if (orderData.length === 0) {
            if (['AUS', 'NZL', 'SGP'].includes(StoreCountry.Country3())) {
                tempGetOrder()
            } else {
                getOrder()
            }
        }

        return () => {
            runInAction(() => {
                storeElement.cardTitle.titleStep1 = ''
                storeElement.settingCard.padding = ''
            })
        }
    }, [])

    const getOrder = async () => {
        setLoading(true)
        try {
            // const response = await FeelGreatAPI.GetSubscriptions(StoreAuth.GetToken())
            const response = await FeelGreatAPI.GetSubscriptionsV2(StoreAuth.GetToken(), StoreAuth.GetId())

            if (response) {
                const filterData = await Promise.all(
                    response.data.ushop.items
                        .filter(item => item.market === StoreCountry.Country2())
                        .map(async data => {
                            let useData = { ...data }

                            // let jpStyle = null
                            // if (useData.market === 'JP') {
                            //     jpStyle = await FeelGreatAPI.GetSubscriptionsItems(StoreAuth.GetToken(), data.href)
                            //     useData = {
                            //         ...useData,
                            //         lines: jpStyle?.data?.lines,
                            //         recurrence: jpStyle?.data?.recurrence,
                            //         shipToAddress: jpStyle?.data?.shipToAddress,
                            //         transactions: jpStyle?.data?.transactions,
                            //         terms: jpStyle?.data?.terms,
                            //         shippingMethod: jpStyle?.data?.shippingMethod,
                            //         shipToEmail: jpStyle?.data?.shipToEmail
                            //     }
                            // }
                            return {
                                ...useData,
                                productItem: useData.lines.items
                                    .map(lineItem => {
                                        let createdItem = {
                                            ...StoreProducts.GetProductByItemCode(lineItem.item.id.unicity),
                                            quantity: lineItem.quantity
                                        }

                                        return createdItem
                                    })
                                    .filter(createdItem => Object.keys(createdItem).length > 1)
                            }
                        })
                )

                setOrderData(filterData)

                const responsePayment = await FeelGreatAPI.Creditcardaliases(StoreAuth.GetToken(), StoreUser.CustomerData().Country())
                if (responsePayment) {
                    setPaymentData(responsePayment.data)
                }
                setLoading(false)
            }
        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }

    // For display item by New SKU data
    const tempGetOrder = async () => {
        console.log('tempGetOrder ')
        setLoading(true)
        try {
            const response = await FeelGreatAPI.GetSubscriptionsV2(StoreAuth.GetToken(), StoreAuth.GetId())

            if (response) {
                const filterData = await Promise.all(
                    response.data.ushop.items
                        .filter(item => item.market === StoreCountry.Country2())
                        .map(async data => {
                            let useData = { ...data }

                            return {
                                ...useData,
                                productItem: useData.lines.items
                                    .map(lineItem => {

                                        const itemCode = lineItem.item.id.unicity

                                        let productByItemCode = null

                                        productByItemCode = StoreProducts.GetProductByItemCode(itemCode)

                                        if (!productByItemCode) {
                                            const newItemCode = StoreProducts.GetNewItemCodeByOldItemCode(itemCode)
                                            if (newItemCode) {
                                                productByItemCode = StoreProducts.GetProductByItemCode(newItemCode)
                                            }
                                        }

                                        let createdItem = {
                                            ...productByItemCode,
                                            quantity: lineItem.quantity
                                        }

                                        return createdItem
                                    })
                                    .filter(createdItem => Object.keys(createdItem).length > 1)
                            }
                        })
                )

                setOrderData(filterData)

                const responsePayment = await FeelGreatAPI.Creditcardaliases(StoreAuth.GetToken(), StoreUser.CustomerData().Country())

                if (responsePayment) {
                    setPaymentData(responsePayment.data)
                    setLoading(false)
                }
            }

        } catch (error) {
            console.log(error)
            setLoading(false)
        }
    }



    return (
        <SubscriptionsStyled loading={loading ? 1 : 0}>
            {loading && <IconSpinner />}
            {!loading && orderData.length === 0 && <NoSubscriptions />}

            {
                !loading && orderData.length !== 0 ?
                    ['AUS', 'NZL', 'SGP'].includes(StoreCountry.Country3()) ?
                        <ItemSubscriptionsMobile order={orderData} payment={paymentData} getOrder={tempGetOrder} />
                        :
                        <ItemSubscriptionsMobile order={orderData} payment={paymentData} getOrder={getOrder} />
                    : null
            }

        </SubscriptionsStyled>
    )
})

const NoSubscriptions = observer(props => {
    const navigate = useNavigate()
    const translate = useTranslate()

    const { width } = useSizeWindow()
    const [showBlockingModal, setShowBlockingModal] = useState(false)

    useEffect(() => {
        runInAction(() => {
            storeElement.settingCard.padding = '0 30px'
        })

        return () => {
            runInAction(() => {
                storeElement.settingCard.padding = ''
            })
        }
    }, [])

    return (
        <Wrapper>
            <Stack textAlign="center" justifyContent="center" alignItems="center" height="100%">
                <RefreshSVG />

                <Typography variant="title" mt="30px" mb="20px" fontSize="24px">
                    <T>no_subscriptions</T>
                </Typography>

                <Typography variant="caption5" textAlign={'center'} mb="40px" color="#023764">
                    <T>no_subscription_description</T>
                </Typography>

                <DefaultButton
                    type="submit"
                    fullWidth={true}
                    titleText={translate('buy_now')}
                    width={width < 428 ? '100%' : '344px'}
                    backgroundcolor="#003B6F"
                    fontSize="20px"
                    fontWeight="400"
                    onClick={() => {
                        if (StoreCountry.Country3() === 'NZL') {
                            setShowBlockingModal(true)
                        } else {
                            navigate('/products')
                        }
                    }}
                />
                {/* Blocking Modal for NZL */}
                <Dialog
                    open={showBlockingModal}
                    onClose={() => setShowBlockingModal(false)}
                    sx={{
                        '& .MuiDialog-paper': {
                            borderRadius: '20px !important',
                            boxShadow: 'none !important',
                            margin: '16px',
                            maxWidth: '400px'
                        }
                    }}>
                    <DialogContent sx={{ padding: '24px' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center'
                            }}>
                            <Typography
                                variant="body1"
                                fontWeight={400}
                                sx={{ fontSize: '16px', color: '#003764', marginBottom: '24px' }}>
                                You will be redirected to our shop to complete your purchase.
                            </Typography>
                            <DefaultButton
                                titleText="Continue to Shop"
                                width={'100%'}
                                onClick={() => {
                                    window.location.href = 'https://u-feelgreat.myshopify.com/'
                                }}
                            />
                        </Box>
                    </DialogContent>
                </Dialog>
            </Stack>
        </Wrapper>
    )
})

const Wrapper = styled(Box)`
    height: 554px;
    width: 100%;
    background: #ffffff;
    display: flex;
    justify-content: center;
`

const SubscriptionsStyled = styled(Stack)`
    justify-content: ${props => (props.loading ? 'center' : 'flex-start')};
    align-items: center;
    min-height: ${props => (props.loading ? '554px' : '100%')};
    height: 100%;
    background: ${props => (props.loading ? '#ffffff' : '#d1d9e2')};
    gap: 15px;
    border-radius: ${props => (props.loading ? '12px' : '0')};
`

const IconSpinner = styled(RefreshIcon)`
    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    width: 65px;
    height: 65px;

    circle {
        stroke: #e2e8ed;
    }
    path {
        stroke: #e2e8f2;
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`

export default SubscriptionsMobile
